<template>
  <div
    class="c-item-overlay"
  >
    <div
      v-if="allowReplace"
      v-b-tooltip.hover
      title="Replace with selected"
      class="c-item-overlay__item add-item replace-item"
      @click="switchItems"
    >
      <b-icon
        icon="arrow-left-right"
        font-scale="1.1"
        style="stroke: #479382; color: #fff; stroke-width: 1.5px"
      />
    </div>
    <div
      class="c-item-overlay__item delete-item"
      @click="decreaseCount"
    >
      <b-icon
        icon="dash-circle-fill"
        font-scale="1.3"
        style="color: #479382; stroke: #fff; stroke-width: 1.5px"
      />
    </div>
    <div
      class="c-item-overlay__item count"
    >
      <span class="count-text">
        {{ countOfItem }}
      </span>
    </div>
    <div
      class="c-item-overlay__item add-item"
      @click="addItem"
    >
      <b-icon
        icon="plus-circle-fill"
        font-scale="1.3"
        style="color: #479382; stroke: #fff; stroke-width: 1.5px"
      />
    </div>
  </div>
</template>


<script>
import { createNamespacedHelpers } from 'vuex'
import {MUTATIONS} from "@frontend/store/file-browser-product-selector";

const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers('fileBrowserProductSelector')

export default {
  name: "ItemOverlay",
  props: {
    item: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      countOfItem: this.count,
      allowReplace: false,
    };
  },
  computed: {
    ...mapGetters([
      'pickedItems',
      'selectedItems',
    ])
  },
  watch:{
    count(newVal) {
      this.countOfItem = newVal;
    },
    selectedItems(newVal) {
      let countItems = 0
      this.pickedItems.map(item => countItems += item.count)
      this.allowReplace = !!(this.pickedItems.find(item => item.id === this.item.id) && this.pickedItems.length === 2 && countItems > 3);
    },
  },
  methods: {
    ...mapActions([
      'pickItem',
      'deleteItem'
    ]),
    ...mapMutations([
        MUTATIONS.TOGGLE_SELECTED_ITEMS,
    ]),
    addItem(e) {
      e.stopPropagation();
      this.pickItem({
        ...this.item,
        count: ++this.countOfItem
      });
    },
    decreaseCount(e) {
      e.stopPropagation();
      if (this.countOfItem > 0) {
        this.deleteItem({
          ...this.item,
          count: --this.countOfItem
        })
      }
    },
    switchItems(e) {
      let sourceItem = this.pickedItems.find(item => item.id !== this.item.id);
      let destinationItem = this.item;
      
      //if clicked on item with count more than source switch items
      if (this.item.count > sourceItem.count) {
        destinationItem = sourceItem;
        sourceItem = this.item;
      }

      this.pickItem({
        ...destinationItem,
        count: sourceItem.count - destinationItem.count,
      });

      this.deleteItem({
        ...sourceItem,
        count: 0
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .c-item-overlay {
    padding: 2px;
    display: flex;
    align-items: end;

    &__item {
      padding-right: 3px;
      cursor: pointer;

      .fa-edit {
        margin-top: 5px;
        color: #747474;
      }
    }

    .replace-item {
      background: #fff;
      -webkit-border-radius: 6px;
      -moz-border-radius: 6px;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px;
      margin-right: 3px;
    }
  }

  .c-item-overlay.folder_overlay {
    padding: 2px;
    display: block;
  }

  .c-item-overlay__item.count {
    font-weight: 900;
    font-size: 18px;
    padding: 5px;
    background: #479382;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    height: 27px;
    border: 1px solid white;
    
    & .count-text {
      text-shadow: 1px 1px 1px #9a9a9a;
    }
  }
</style>
